<template>
  <FilterHeader
    class="search-filter"
    :data-cy="dataCy"
    :title="filterTitle"    
    :selections="selections"
    :filterDisabled="filterDisabled"
    :disable-btn="disableBtn"    
    @submitFilter="submitFilter"
    @cleanSelected="cleanSelected"
    @defaultSelections="defaultSelections"
    @checkSelections="checkSelections"
  >
    <ul class="pa-0 mr-5 list-style-none rtl" :data-cy="`${dataCy}`">
      <li v-for="(item, index) in filterOptions" :key="index">
        <v-checkbox
          v-model="selections"
          :label="item.NameInHebrew"
          :value="item.Code"
          :data-cy="`${dataCy}${index}`"
          class="mt-0"
          :hide-details="true"
          @change="checkSelections"
        ></v-checkbox>
      </li>
    </ul>
  </FilterHeader>
</template>


<script>
import FilterBaseVue from './mixins/FilterBase.vue'

export default {
  mixins: [FilterBaseVue]
}
</script>
